import { Advice } from "./Advice";
import { CoachSkill } from "./CoachSkill";
import { Consent } from "./Consent";
import { Country } from "./Country";
import { IntakeProfile } from "./IntakeProfile";
import { Practice } from "./Practice";
import { QuestionnaireResult } from "./QuestionnaireResult";
import { UserTag } from "./UserTag";

export const LOGIN_URL = '/v3/users/login';
// export const LOGOUT_URL = '/v3/users/logout';
export const LOGOUT_URL = '/users/logout';
// export const RENEW_URL = '/v3/users/renew_sign_in';
export const RENEW_URL = '/users/renew_sign_in';
//
export const loginFields = [
  'id', 'first_name', 'last_name', 'auth_token', 'email', 'is_admin', 'extra_data', 'get_item_thumb', 'type', 'settings', 'goal_weight',
  'practice|id/name/item_is_square/get_medium/url_path', 'full_move_groups', 'full_eat_groups', 'calendar_url', 'ehealth', 'country_id', 'is_secretary',
  'is_super', 'mfa_status', 'is_extended_intake', 'override_theme', 'gender', 'calculated_adh_profile_id', 'adh_profile_id'
];

export type User = {
  id?: number;
  auth_token: string;
  created_at?: string;
  email: string;
  first_name?: string;
  second_name?: string;
  last_name?: string;
  call_name?: string;
  spouse_name?: string;
  type?: string;
  practice_id?: number;
  goal_weight?: number;
  calendar_url?: string;
  country_id?: number;
  language_id?: number;
  birth_date?: string;
  phone_mobile?: string;
  phone_fixed?: string;
  password?: string;
  password_repeat?: string;
  is_agreed?: boolean;
  is_agreed_practice?: boolean;
  enabled?: boolean;
  is_super?: boolean;
  merge_pending?: boolean;
  is_public?: boolean;
  consent_status?: {
    id: number;
    enabled: boolean;
    is_basic?: boolean;
    is_intake?: boolean;
    is_measure_weight?: boolean;
    is_diary_eat?: boolean;
    is_diary_move?: boolean;
    pending?: boolean;
    is_blocked?: boolean;
    nutri_id?: string;
    episode?: number;
    is_daynote?: boolean;
    is_blood?: boolean;
    is_blood_default?: boolean;
  };
  is_secretary?: boolean;
  gender?: number;
  calculated_adh_profile_id?: number;
  adh_profile_id?: number;
  national_number?: string;
  last_diary_entry?: string;
  current_sign_in_at?: string;
  last_sign_in_at?: string;
  sort_order?: number;

  street?: string;
  number?: string;
  zip?: string;
  city?: string;

  episode?: number;
  episodes?: string[];

  ehealth_cert_complete?: boolean;
  ehealth_cert_file_name?: string;

  mfa_status?: number;
  known_practice_list?: number[];

  ehealth_cert?: File;
  item?: File;

  is_background_colour?: boolean;
  background_colour?: string;
  is_extended_intake?: boolean;

  full_eat_groups?: {
    [z:string]: {
      profile: {
        name: string,
        questions: string[]
      },
      practices: [id:number, name:string][]
    }
  };

  full_move_groups?: {
    [z:string]: {
      profile: {
        name: string,
        questions: string[]
      },
      practices: [id:number, name:string][]
    }
  };

  full_profile_text?: {
    [n:number]: string;
  }

  secretary_allowed?: {
    locations: number[];
    types: number[];
  }

  ehealth?: {
    connection_data?: {
      ssin?: string;
      type?: string;
      quality?: string;
    };
    connect?: string;
    status?: {
      key: string;
      stamp: string;
    };
    p12_status?: boolean;
    expiry?: {
      any?: boolean;
      error?: string;
    }
  }

  extra_data?: {
    dashboard?: {
      hide_weight?: boolean;
    },
    internal_comments?: {
      [practiceId: string]: string;
    },
    emails?: {
      account?: boolean;
      newsletter?: boolean;
      nutri_appointment?: boolean;
      nutri_mail?: boolean;
      nutri_workshop?: boolean;
      coach_nutri_workshop?: boolean;
      force_email_on_nutrimail?: boolean;
    },
    nutri_advice?: {
      start_cloned?: boolean;
      ignore_intake?: boolean;
      use_advanced_index?: boolean;
    },
    nutri_mail?: {
      signature?: string;
    },
    is_guest?: boolean;
    restricted_saved?: boolean;
    restricted_accepted_gdpr?: boolean;
    use_10_minute_slots?: string;
    weight_trigger?: number;
    zorgmail?: {
      username?: string;
      password?: string;
    };
    dutch?: {
      voorletters?: string;
      province?: string;
      man_name_pre?: string;
      girl_name_pre?: string;
    };
    partner_ids?: {
      synapse?: string;
    };
    disabled_notifications?: {
      new_episode?: number[];
    };
  };

  settings?: {
    dashboard?: {
      hide_weight?: boolean;
    },
    nutri_advice?: {
      ignore_intake?: boolean;
      start_cloned?: boolean;
      use_advanced_index?: boolean;
    },
    ehealth_mail?: {
      signature?: string;
    },
    nutri_mail?: {
      signature?: string;
    },
    is_background_colour?: boolean;
    background_colour?: string;
    notifications?: {
      account?: boolean;
      newsletter?: boolean;
      nutri_appointment?: boolean;
      nutri_mail?: boolean;
      nutri_workshop?: boolean;
    },
    use_10_minute_slots?: boolean;
    userdetail_widgets?: {
      left_col?: string[];
      mid_col?: string[];
      right_col?: string[];
      settings?: { [widgetKey: string]: any };
    }
  }

  coach_skills: CoachSkill[];
  coach_skill_ids?: number[];
  profile_text?: string;
  get_profile_text?: string;

  full_fm_links?: {
    [z:string]: string;
  }

  ehealth_stuff?: {
    p12_pass?: string;
  };

  module_status?: {
    diary?: boolean;
    measures?: boolean;
    diary_day?: string;
    measures_day?: string;
  }

  override_theme?: {
    id?: string;
    primary_main: string;
    contrast_main: string;
    tertiary_main: string;
    onboarding_bg?: string;
    primary_main_light?: string;
    primary_main_dark?: string;
    tertiary_main_light?: string;
    tertiary_main_dark?: string;
    text_colour?: string;
    workshops_plural?: string;
    workshops_singular?: string;
  }

  last_activity?: string;

  org_name?: string;

  readonly custom_api_get_intake_progress?: number;

  readonly appointments_after_now_count?: number;
  readonly appointments_before_now_count?: number;

  readonly get_item_thumb?: string;
  readonly get_medium?: string;
  readonly get_bg_medium?: string;

  readonly practice_get_medium?: string;
  readonly practice_name?: string;
  readonly practice_item_is_square?: boolean;
  readonly practice_url_path?: string;
  readonly practice_support_email?: string;
  readonly practice_zip?: string;
  readonly practice_city?: string;
  
  readonly workshops_after_now_count?: number;
  readonly workshops_before_now_count?: number;

  readonly advices_count?: number;
  readonly practice_advices_count?: number;
  readonly advice_uploads_count?: number;

  readonly full_name?: string;

  readonly country_name?: string;
  readonly country?: Country;

  readonly last_appointment?: string;

  readonly practice?: Practice;
  readonly questionnaire_results?: QuestionnaireResult[];
  readonly intake_profile?: IntakeProfile;
  readonly intake_profile_practice?: IntakeProfile;
  readonly intake_profiles_practice?: IntakeProfile[];
  readonly user_tags?: UserTag[];

  readonly ai_data?: {
    success: boolean;
    profile: {
      birth_date?: string;
      gender?: string;
    };
    intake: {
      practician: string;
      insurance: string;
      extra_insurance: string;
      convention: string;
      height: string;
      weight: string;
      weight_progress: string;
      civil_state: string;
      children: string;
      diagnoses: string;
      complaints: string;
      medication: string;
      allergies: string;
      history: string;
      situation_home: string;
      situation_work: string;
      hobbies: string;
      sports: string;
      is_smoker: boolean;
      comment_smoker: string;
      is_alcohol: boolean;
      comment_alcohol: string;
      hours_sit: string;
      is_sleep_okay: boolean;
      hours_sleep: string;
      relaxation: string;
      hours_screen: string;
      stress_score: string;
      food_pattern: string;
      consult_initiative: string;
      consult_reason: string;
      doctor_note: string;
      consult_expectation: string;
      motivation_score: string;
      goals: string;
    };
    practice_intake: {
      practician: string;
      insurance: string;
      extra_insurance: string;
      convention: string;
      height: string;
      weight: string;
      weight_progress: string;
      civil_state: string;
      children: string;
      diagnoses: string;
      complaints: string;
      medication: string;
      allergies: string;
      history: string;
      situation_home: string;
      situation_work: string;
      hobbies: string;
      sports: string;
      is_smoker: boolean;
      comment_smoker: string;
      is_alcohol: boolean;
      comment_alcohol: string;
      hours_sit: string;
      is_sleep_okay: boolean;
      hours_sleep: string;
      relaxation: string;
      hours_screen: string;
      stress_score: string;
      food_pattern: string;
      consult_initiative: string;
      consult_reason: string;
      doctor_note: string;
      consult_expectation: string;
      motivation_score: string;
      goals: string;
    };
    advices: Advice[];
  }
  readonly consents?: Consent[];
}
